RivalIQ.apps.Insights.module('data', function (data, App, Backbone, Marionette, $, _, s) {

    'use strict';

    function isObjectRequest(attributes) {
        const freeDimension = _.head(RivalIQ.metric.getFreeDimensions(attributes));

        // NOTE treat keywords as an object request type, so that sorts/limits/etc. are included in the cache key for keywords
        // NOTE same for storyDay
        // NOTE same for excludeNullPosts, as the sort is relevant there
        return (freeDimension && (RivalIQ.enums.insightsObjectType[freeDimension] || freeDimension === 'keyword')) ||
            attributes.storyDay ||
            attributes.excludeNullPosts;
    }

    function sortOptional(cacheValue, fetchValue, attributes) {
        return !isObjectRequest(attributes) || !_.exists(fetchValue) || _.isEqual(cacheValue, fetchValue);
    }

    const cacheKeys = [
        'searchTerm',
        'channel',
        'mediaTypeFilter',
        'tweetTypeFilter',
        'postTagIds',
        'postTagConjunction',
        'postTagExclude',
        'mustHavePostTagIds',
        'includeSummaryRow',
        'aggregateOnPostTags',
        'excludeNullPosts',
        'storyDay',
        'timezone',
        'hashtagSortOrder',
        'hashtagOrderBy',
        'hashtagLimit',
        'keywordsLimit',
        'hashtagsMinPosts',
        'property',
        'timeAnalysisMode',
        'analysisProperty',
        'objectType',
        'keywordsMinPosts',
        'landscapeId',
        'postIds',
        RivalIQ.data.CacheLayer.keyType.TIMEPERIOD,
        'companyId',
        'channel',
        'startDate',
        'endDate',
        'compareStartDate',
        'compareEndDate',
        'timeAnalysisMode',
        {
            value: 'sortOrder',
            test: sortOptional
        },
        {
            value: 'orderBy',
            test: sortOptional
        },
        {
            value: 'limit',
            test: function (cacheValue, fetchValue, attributes) {

                return (!isObjectRequest(attributes)) ||
                    !_.exists(fetchValue) ||
                    cacheValue === -1 ||
                    (cacheValue >= fetchValue && fetchValue !== -1);
            }
        },
        {
            value: 'dimensions',
            test: function (cacheValue, fetchValue) {

                cacheValue = cacheValue || [];
                fetchValue = fetchValue || [];
                return _.size(cacheValue) === _.size(fetchValue) &&
                    fetchValue.sort().join('-') === cacheValue.sort().join('-');
            }
        }
    ];

    const allCacheKeys = _(cacheKeys)
        .map(function (e) {
            return _.get(e, 'value', e);
        })
        .uniq()
        .value();

    const InsightsCacheLayer = RivalIQ.data.BatchCacheLayer.extend({
        // ideally we could use _.unionWith once we move to a newer version of lodash
        cacheKeys: _.uniqBy(cacheKeys, function (e) {
            return _.get(e, 'value', e);
        }),

        loadData: function (requests) {
            const me = this;

            const collection = new me.Collection();

            const data = _.map(requests, function (request) {
                const singleRequest = _.extend({}, _.pick(request, allCacheKeys));
                singleRequest.timePeriod = request.timePeriod;
                singleRequest.dimensions = request.dimensions;
                return singleRequest;
            });

            return collection.fetch({
                data: data
            });
        },

        fetch: function (params) {
            const me = this;

            return me.getOrLoad(App.collections.normalizeInsightsParams(params));
        },

        _resolveFromMatchingRequest: function (cache, data) {
            if (_.has(data, ['error'])) {
                cache.data.deferred.reject(data);
            } else {
                cache.data.deferred.resolve(data);
            }
        }

    });

    const cacheLayers = [
        {
            name: 'StoryDay',
            Collection: App.collections.StoryDay
        },
        {
            name: 'Story',
            Collection: App.collections.Story
        },
        {
            name: 'FollowerOnlineTimes',
            Collection: App.collections.FollowerOnlineTimes
        },
        {
            name: 'Post',
            Collection: App.collections.Post
        }
    ];

    _.reduce(cacheLayers, function (memo, cacheLayer) {
        const CacheLayer = InsightsCacheLayer.extend(cacheLayer);
        return _.set(memo, s.decapitalize(cacheLayer.name), new CacheLayer());
    }, data);

}, window.s);
